export default [
  {
    path: '/coworkers/installers',
    name: 'installers',
    component: () => import('@/pages/coworkers/InstallersPage.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_coworker_installer',
    },
  },
  {
    path: '/coworkers/managers',
    name: 'coworkers',
    component: () => import('@/pages/coworkers/ManagersPage.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_coworker_manager',
    },
  },
]
